<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-21 20:44:05
-->
<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <!-- <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.commId"
                        clearable
                        filterable
                        placeholder="请选择小区"
                >
                <el-option v-for="item in optionList"
                            :key="item.id"
                            :label="item.commName"
                            :value="item.id" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.type"
                        clearable
                        filterable
                        placeholder="请选择类型"
                >
                <el-option label="出租" :value="1" />
                <el-option label="出售" :value="2" />
                </el-select>
            </div> -->
            <!-- <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.title"
                    size="mini"
                    clearable
                    placeholder="请输入关键词查找"
                />
            </div> -->
            <div class="shaixuan-item">
                <!-- <el-button
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    @click="searchClick()"
                    icon="el-icon-search"
                >
                    查询
                </el-button> -->
                <el-button
                    @click="clickItem(0)"
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    icon="el-icon-plus"
                >
                    新增
                </el-button>
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table
                v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px"
            >
                <el-table-column prop="id" label="id" width="80" />
                <el-table-column label="租售类型" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">出租</span>
                        <span v-if="scope.row.type == 2">出售</span>
                        <span v-if="scope.row.type == 3">求租</span>
                        <span v-if="scope.row.type == 4">求购</span>
                    </template>
                </el-table-column>
               
                <el-table-column label="小区" minWidth="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.community">{{ scope.row.community.commName }}</span>
                    </template>
                </el-table-column>
                 <el-table-column label="资源类型" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type == 1">住宅</span>
                        <span v-if="scope.row.zushou_type == 2">车位</span>
                        <span v-if="scope.row.zushou_type == 3">车库</span>
                        <span v-if="scope.row.zushou_type == 4">储间</span>
                        <span v-if="scope.row.zushou_type == 5">商业</span>
                        <span v-if="scope.row.zushou_type == 6">写字楼</span>
                    </template>
                </el-table-column>
                <el-table-column label="户型" minWidth="60">
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1">{{ scope.row.shi ? scope.row.shi + '室' : '' }}{{ scope.row.ting ? scope.row.ting + '厅' : '' }}{{ scope.row.wei ? scope.row.wei + '卫' : '' }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="zushou_name" label="号码" minWidth="60" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1">
                            -
                        </span>
                        <span v-else-if="scope.row.zushou_type==2">
                            车位号:{{ scope.row.zushou_name }}
                        </span>
                        <span v-else-if="scope.row.zushou_type==3">
                            车库号:{{ scope.row.zushou_name }}
                        </span>
                        <span v-else-if="scope.row.zushou_type==4">
                            储间号:{{ scope.row.zushou_name }}
                        </span>
                        <span v-else-if="scope.row.zushou_type>4">
                            房号:{{ scope.row.zushou_name }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="floor" label="位置" minWidth="40" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==5">{{ scope.row.address }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="floor" label="楼层" minWidth="40" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1||scope.row.zushou_type==6">{{ scope.row.floor }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="area" label="面积" minWidth="40" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1||scope.row.zushou_type==5||scope.row.zushou_type==6">{{ scope.row.area }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="person" label="联系人" width="100" />
                <el-table-column prop="phone" label="联系电话" minWidth="100" />
                <!-- <el-table-column prop="area" label="面积" minWidth="100" /> -->
                <el-table-column prop="price" label="售价" minWidth="100" />
                <el-table-column prop="sale_remark" label="成交备注" minWidth="100" />
                <!-- <el-table-column prop="admin" label="状态">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="0"
                            @change="changeStatus(scope.row)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="admin" label="排序" width="120">
                    <template slot-scope="scope">
                        <el-input-number
                            size="mini"
                            style="width: 100px"
                            v-model="scope.row.sort"
                            controls-position="right"
                            @change="handleChange(scope.row)"
                            :min="0"
                        ></el-input-number>
                    </template>
                </el-table-column> -->
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <el-button
                                type="danger"
                                style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                                @click="clickItem(1, scope.row)"
                                >修改</el-button
                            >
                            <el-button
                                type="danger"
                                v-show="scope.row.sale_status == 0"
                                @click="sale(scope.row)"
                                style="
                                    background: #fd962b;
                                    border-color: #fd962b;
                                "
                                >成交</el-button
                            >
                            <el-button
                                type="danger"
                                @click="remove(scope.row)"
                                style="
                                    background: #ff4949;
                                    border-color: #ff4949;
                                "
                                >删除</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination
                v-show="total"
                :total="total"
                :page.sync="queryParam.page"
                :limit.sync="queryParam.size"
                @pagination="getList"
            />
        </div>
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="1000px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
                    <i
                        class="el-icon-circle-close close-btn pointer"
                        @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <commonAdd
                    ref="commonAdd"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
            </div>
        </el-drawer>
        <el-dialog
            title="提示"
            :visible.sync="showDialog"
            width="30%"
            center>
            <!-- <span>确定标记成交吗？</span> -->
            <el-form
                ref="ruleForm"
                :model="viewData"
                :rules="rules"
                label-width="60px"
            >
                <el-form-item label="备注" prop="sale_remark">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="viewData.sale_remark">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="sure('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/sell";
import Qu from "@/api/tianzheng/Qu";
import commonAdd from "./BoutiqueAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            optionList: [],
            queryParam: {
                type:'',
                commId:'',
                zushou_type: "1",
                dyl_zushou_type: '',
                page: 1,
                size: 10,
            },
            total: 0,
            listLoading: false,
            tableData: [],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
            viewData:{
                sale_remark:''
            },
            rules: {
                sale_remark: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
            },
            showDialog:false
        };
    },
    components: {
        Pagination,
        commonAdd,
    },
    created() {},
    mounted() {
        this.getList();
        this.getSelectCity()
    },
    methods: {
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        // 排序变更
        handleChange(row) {
            let params = {
                id: row.id,
                sort: row.sort,
            };
            fetch.sort(params).then((res) => {
                if (res.code == 200) {
                    this.getList();
                } else {
                    this.getList();
                    this.$message.error(res.message);
                }
            });
        },
        /**
         * @name: 更改状态
         * @param {*} val
         * @return {*}
         * @desc:
         */
        changeStatus(val) {
            let params = {
                id: val.id,
                status: val.status,
            };
            fetch.status(params).then((res) => {
                if (res.code == 200) {
                    this.getList();
                } else {
                    this.getList();
                    this.$message.error(res.message);
                }
            });
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            console.log("status", status);
            if (status == 1) {
                // 成功
                this.showDrawer = false;
                this.getList();
            } else if (status == -1) {
                // 失败
                // this.showDrawer = false;
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false;
            if (this.$refs.commonAdd){
                this.$refs.commonAdd.resetForm();
            }
        },
        /**
         * @name: 点击子项 0新增 1编辑
         * @param {*} type
         * @param {*} id
         * @return {*}
         * @desc:
         */
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.commonAdd.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
            let that = this;
            this.listLoading = true;
            fetch.banner(that.queryParam).then((res) => {
                that.listLoading = false;
                that.tableData = res.result.list;
                that.total = res.result.total;
            });
        },
        sale(row){
            this.showDialog = true
            this.viewData.id = row.id
            this.viewData.sale_remark = ''
            this.$refs["ruleForm"].resetFields();
        },
        sure(formName) {
            let that = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    fetch.sale(that.viewData).then((res) => {
                        that.showDialog = false
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        remove(row) {
            let that = this;
            that.$confirm("确定删除该内容吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // 调用接口
                    fetch.remove({ id: row.id }).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
